import React from 'react';
import DocumentViewer from '../components/DocumentViewer';
import { useMarkdownContent } from '../hooks/useMarkdownContent';

const CancellationPolicyPage: React.FC = () => {
  const { content, loading, error } = useMarkdownContent('cancellation-policy.md');

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading Cancellation Policy...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center text-red-600">
          <p>Error loading Cancellation Policy: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <DocumentViewer
      content={content}
      title="Cancellation Policy"
      filename="baakas-cancellation-policy"
    />
  );
};

export default CancellationPolicyPage;